import { useState, useEffect } from 'react'

export default () => {
  const MAX_WIDTH_SIZE = 599

  const [desktopResolution, setDesktopResolution] = useState(
    window.innerWidth > MAX_WIDTH_SIZE
  )

  const updateResolution = () => {
    setDesktopResolution(window.innerWidth > MAX_WIDTH_SIZE)
  }

  useEffect(() => {
    window.addEventListener(`resize`, updateResolution)
    return () => window.removeEventListener(`resize`, updateResolution)
  })

  return desktopResolution
}
